import { render, staticRenderFns } from "./GrowthMarkerEntry.vue?vue&type=template&id=5b4a74bc&scoped=true&"
import script from "./GrowthMarkerEntry.vue?vue&type=script&lang=js&"
export * from "./GrowthMarkerEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a74bc",
  null
  
)

export default component.exports